import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { API } from "@/lib/api";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Leasing from "@/pages/Leasing";
import Admin from "@/pages/Admin";
import Prepaid from "@/pages/Prepaid";
import Fuel from "@/pages/Fuel";
import Placeholder from "@/pages/Placeholder";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">Se încarcă…</div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/leasing" replace />;
  return <Layout>{children}</Layout>;
}

// Full-screen, auth-gated user manual. Without a session -> redirect to login.
// Renders the static manual (served by the backend) in an iframe, preserving the #section anchor.
function ManualGate() {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Se încarcă…</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  const hash = window.location.hash || "";
  return (
    <iframe
      title="Manual utilizare Portal"
      data-testid="manual-iframe"
      src={`${API}/manual/index.html${hash}`}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: 0 }}
    />
  );
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/manual" element={<ManualGate />} />
      <Route path="/manual/*" element={<ManualGate />} />
      <Route path="/" element={<Protected><Home /></Protected>} />
      <Route path="/leasing" element={<Protected><Leasing /></Protected>} />
      <Route
        path="/cheltuieli-in-avans"
        element={<Protected><Prepaid /></Protected>}
      />
      <Route
        path="/carburanti"
        element={<Protected><Fuel /></Protected>}
      />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
